export const URLS = {
  DETAIL: '/detail/',
  HOME: '/',
  WORK: '/work',
  SERVICE: '/service',
  ABOUT_US: 'https://www.agilityio.com'
}



// WEBPACK FOOTER //
// ./src/constants/routes.js